import { Flex, Text } from '@buffer-mono/popcorn'

import type { CommentsScoreResponse } from '~publish/gql/graphql'

import { CommentScoreMetric } from '../components/CommentScoreMetric'
import { DetailedMetrics } from '../components/DetailedMetrics'

import styles from './ScoreContent.module.css'

const CommentsScoreHeader = (): JSX.Element => {
  return (
    <header className={styles.header}>
      <Text size="md" weight="bold" className={styles.headerTitle}>
        Comment score
      </Text>
      <Text size="sm" color="subtle">
        Rates your ability to stay engaged with your audience.
      </Text>
    </header>
  )
}

export const ScoreContent = ({
  commentsScore,
}: {
  commentsScore: CommentsScoreResponse
}): JSX.Element => {
  return (
    <article className={styles.cardContainer}>
      <CommentsScoreHeader />
      <section className={styles.body}>
        <div className={styles.bodyWrapper}>
          <CommentScoreMetric
            level={commentsScore.currentAchievementLevel}
            score={commentsScore.currentWeekScore.totalValue}
          />
          <Flex direction="column" gap="lg" justify="center">
            <DetailedMetrics
              responseRate={commentsScore.currentWeekScore.responseRate}
              responseSpeed={commentsScore.currentWeekScore.responseSpeed}
              consistency={commentsScore.currentWeekScore.consistency}
            />
            <Text size="sm" color="subtle">
              Comment score is calculated weekly based on response rate (50% of
              total score), response speed (30%), and consistency (20%).
            </Text>
          </Flex>
        </div>
      </section>
    </article>
  )
}
